import React, { useEffect, useState } from "react";
import StyledDropdown from "@/components/common/styled-dropdown";
import { useTextToSpeechContext } from "@/components/pages/text-to-speech/components/providers/text-to-speech-provider";

const SpeechLanguagesDropdown = () => {
  const { settings, handleLanguageChange } = useTextToSpeechContext();

  const [value, setValue] = useState("English");

  useEffect(() => {
    setValue(settings.language);
  }, [settings.language]);

  const handleChange = (newValue: any) => {
    if (newValue !== value) {
      setValue(newValue);
      handleLanguageChange(newValue);
    }
  };

  const languages = [
    { label: "English" },
    { label: "French" },
    { label: "German" },
    { label: "Italian" },
    { label: "Portuguese" },
    { label: "Polish" },
    { label: "Turkish" },
    { label: "Russian" },
    { label: "Dutch" },
    { label: "Czech" },
    { label: "Arabic" },
    // { label: "Chinese" },
    // { label: "Japanese" },
    { label: "Hungarian" },
    { label: "Korean" },
  ].sort((a, b) => a.label.localeCompare(b.label));

  return (
    <StyledDropdown
      currentValue={value}
      values={languages.map((lang) => lang.label)}
      onChanged={handleChange}
    />
  );
};

export default SpeechLanguagesDropdown;
